import {Directive, Input, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {RuntimeCacheService} from '../services/runtime-cache.service';

/**
 * yascPermission from lib does not work. It seams like angular has issue
 * to resolve the different RuntimeCacheService types....
 */
@Directive({
    selector: '[cpPermission]',
    standalone: false
})
export class PermissionDirective implements OnInit {
    @Input() cpPermission = ""

    constructor(private runtime: RuntimeCacheService, private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef) {
    }

    public renderComponent(): void {
        if (!this.runtime.hasPermission(this.cpPermission)) {
            this.viewContainer.clear();
        } else {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
    }

    ngOnInit() {
        this.renderComponent()
    }
}